module.exports = __webpack_public_path__ + "static/media/IrSammyYeung.ba096d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub1/IrSammyYeung.jpg
// module id = 200
// module chunks = 0